// extracted by mini-css-extract-plugin
export default {"timeDivider":"MessageDivider__timeDivider--B7tCr"};